﻿$.fn.dxCtrlContentEnvoiTracking = function custom_dxCtrlContentEnvoiTracking(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlcontentenvoitracking dx-ctrl");
        this.createInstance(new cdxCtrlContentEnvoiTracking(this, option));
    }
    return this;
}

window.cdxCtrlContentEnvoiTracking = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }


    var idTable = option.bddCtrl.getObjet(option.data).mGetTable().id_table
    var id = option.bddCtrl.getObjet(option.data).cle()
    var type = "email"
    if (option.bddCtrl.getObjet(option.data).mGetTable().nom == "com_sms_envoi") type = "sms"
    var $DivContentStat = null
    var $DivContentDest = null;
    var $DivContentVue = null
    var $DivContentClick = null
    var $DivContentDesinscription = null
    var $DivContentBounce = null
    var $DivContentMessage = null
    function mConstruit() {
        container.empty()

        var $DivWarning = $("<div/>").appendTo(container)
        if (option.data.id_type_classement == 8) {
            $("<div style='margin:2px;'/>").appendTo($DivWarning).dxCtrlWarningForm({
                type: "warning",
                icon: "fas fa-information",
                contentTemplate: function (contentElement) {
                    var $Table = $("<table/>").appendTo(contentElement)
                    var $Tr = $("<tr/>").appendTo($Table)
                    //var $TdMessage = $("<td style='width:100%;'></td>").appendTo($Tr)
                    if ((new Date(option.data.date_envoi)).addMinutes(-5) > parametre.dateNow && option.data.ignore_attente_compte_email == "1") {
                        //on une date d'envoi programmé 
                        var $Td = $("<td style='width:100%;'>L'envoi de votre message est programmé " + option.data.date_envoi.toDateIlya() + " (" + option.data.date_envoi.toFrenchDateTime() + ")</td>").appendTo($Tr)
                    } else {
                        var $Td = $("<td style='width:100%;'>Votre message est en attente d'envoi </td>").appendTo($Tr)
                        $A = $("<a href='javascript:void(0)'>conformément à la configuration de votre compte email</a>").appendTo($Td)
                        $A.on("click", function (e) {
                            e.stopPropagation()
                            option.bddCtrl.getObjet("compte_email", option.data.id_compte_email).objetMetier.mShowPopup({
                                id_utilisateur: option.bddCtrl.utiCourant.id_utilisateur,
                                idAccordion: 2
                            })
                        })
                    }
                    var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                    $("<div/>").appendTo($Td).dxCtrlButton({
                        text: "Annuler envoi",
                        hint: "Annuler l'envoi et mettre l'email dans les brouillons",
                        onClick: function (e) {
                            page.mRemovePopup(option.data)
                            option.data.date_envoi = null
                            option.data.id_type_classement = 7
                            option.bddCtrl.getObjet(option.data).mSave(function (data) {
                                option.bddCtrl.getObjet(option.data).mShowPopup()
                            })
                        }
                    })
                    var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                    $("<div/>").appendTo($Td).dxCtrlButton({
                        text: "envoyer immédiatement",
                        hint: "Ignorer le paramètrage du compte email et envoyer immédiatement l'email",
                        onClick: function (e) {
                            page.mRemovePopup(option.data)
                            option.data.ignore_attente_compte_email = "1"
                            option.data.id_type_classement = 9
                            option.data.date_envoi = parametre.dateNow
                            option.bddCtrl.getObjet(option.data).mSave()
                        }
                    })

                    function mDecompte() {
                        if ($Table.closest("body").length == 0 || option.data.date_envoi == null) return
                        var newDataEnvoi = option.bddCtrl.getObjet("com_email_envoi", option.data.id_com_email_envoi).data
                        if (!newDataEnvoi) page.mRemovePopup(option.data)
                        if (newDataEnvoi.id_type_classement != option.data.id_type_classement) {
                            page.mRemovePopup(option.data)
                        } else {
                            window.setTimeout(function () { mDecompte() }, 3000)
                        }
                        //if ($TdMessage.closest("body").length == 0 || option.data.date_envoi == null) return
                        //let totalSeconds = 500;
                        //let minutes = Math.floor(totalSeconds / 60);
                        //let seconds = totalSeconds % 60;
                        //var dataCompteEmail = option.bddCtrl.mGetArray("compte_email").filter(function (o) { return o.id_compte_email == option.data.id_compte_email })[0]
                        //if (dataCompteEmail.envoi_temporisation_mn != null && option.data.ignore_attente_compte_email == "0") {
                        //    $TdMessage.html("L'envoi de vos emails est temporisé.<br/>L'email sera envoyé dans " + (new Date()).decompte(option.data.date_envoi))
                        //} else if ((new Date(option.data.date_envoi)).addMinutes(-5) > parametre.dateNow && option.data.ignore_attente_compte_email == "1") {
                        //    $TdMessage.html("Une date d'envoi dans le futur a été programmée.<br/>L'email sera envoyée dans " + (new Date()).decompte(option.data.date_envoi) + " (" + option.data.date_envoi.toFrenchDateTime() + ").")
                        //} else {
                        //    $TdMessage.html("L'envoi de vos emails est temporisé.<br/>L'email sera envoyé dans " + (new Date()).decompte(option.data.date_envoi))
                        //}
                        //if (diffdate(parametre.dateNow, option.data.date_envoi, "s") < 3) {
                        //    page.mRemovePopup(option.data)
                        //    //funcDepasse()
                        //} else { window.setTimeout(function () { mDecompte() }, 3000) }
                    }
                    mDecompte()
                }
            }).dxCtrlWarningForm("instance")
        }

        //id_type_smtp_forcer
        var dxWarningForm = null
        if (type == "email" && (option.data.nb_spam_bascule != null || option.data.nb_spam_bascule2 != null || option.data.nb_bounce_bascule != null)) {
            dxWarningForm = $("<div style='margin:5px'/>").appendTo($DivWarning).dxCtrlWarningForm({
                type: "warning",
                contentTemplate: function (contentElement) {
                    option.bddCtrl.mAjaxCall({ command: "getdataslstdestnb", idtablecom: idTable, idcom: id }, function (data) {
                        data.lstcomdest = JSON.parse(data.lstcomdest)
                        var nbTotal = data.lstcomdest[0].nb
                        contentElement.css("font-family", "barlow condensed")
                        var txt = ""
                        if (option.data.nb_spam_bascule != null) {
                            //on a basculé en SPAM
                            var percentEnvoi = (option.data.nb_envoi_spam_bascule / nbTotal * 100).toFixed(2)
                            txt = "&bull; L'envoi de votre emailing a dépassé le <a href='" + parametre.url_cognoss + "/" + parametre.code_appli + "/0/22/qu_est_ce_que_le_taux_de_spam/bc' target='_blank'>taux de spam</a> (à <b>" + option.data.tx_spam_limit + "%</b> d'emails envoyés) autorisé à " + percentEnvoi + "% de votre envoi. "
                            //if (option.bddCtrl.objCptCli.objetMetier.hasServeurSmtpDedie()) {
                            //    txt += "Pour optimisez la délivrabilité de votre envoi et pour protéger votre smtp dédié, tous les messages suivants envoyés à des destinataires disposant d'adresse email gratuite (gmail, outlook, yahoo...) ont été envoyés en <a href='" + parametre.url_cognoss + "/" + parametre.code_appli + "/0/39/mode_degrade/bc' target='_blank'>mode dégradé</a>."
                            //} else {
                            txt += "Pour optimisez la délivrabilité de votre envoi et pour protéger nos serveurs mutualisés et garantir une délivrabilité optimale pour tous nos utilisateurs, tous les messages suivants envoyés à des destinataires disposant d'adresse email gratuite (gmail, outlook, yahoo...) ont été envoyés en <a href='" + parametre.url_cognoss + "/" + parametre.code_appli + "/0/39/mode_degrade/bc' target='_blank'>mode dégradé</a>."
                            //}

                            if (option.data.nb_spam_bascule2 != null) {
                                //on a RE-basculé en SPAM
                                var percentEnvoi = (option.data.nb_envoi_spam_bascule2 / nbTotal * 100).toFixed(2)
                                txt += "<br/>&bull; Malgré le basculement des emails gratuites en mode dégradé, une nouvelle mise en SPAM a eu lieu à <b>" + percentEnvoi + "%</b> de votre envoi. "
                                //if (option.bddCtrl.objCptCli.objetMetier.hasServeurSmtpDedie()) {
                                //    txt += "pour protéger votre smtp dédié, tous les messages suivants ont été envoyés en <a href='" + parametre.url_cognoss + "/" + parametre.code_appli + "/0/39/mode_degrade/bc' target='_blank'>mode dégradé</a>."
                                //} else {
                                txt += "pour protéger nos serveurs mutualisés et garantir une délivrabilité optimale pour tous nos utilisateurs, tous les messages suivants ont été envoyés en <a href='" + parametre.url_cognoss + "/" + parametre.code_appli + "/0/39/mode_degrade/bc' target='_blank'>mode dégradé</a>."
                                //}

                            }
                        }
                        if (option.data.nb_bounce_bascule != null) {
                            //on a basculé en bounce
                            var percentEnvoi = (option.data.nb_envoi_bounce_bascule / nbTotal * 100).toFixed(2)
                            txt += ((txt.length > 0) ? "<br/>&bull; " : "") + "L'envoi de votre emailing a dépassé le <a href='" + parametre.url_cognoss + "/" + parametre.code_appli + "/0/21/qu_est_ce_que_le_taux_de_bounce/bc' target='_blank'>taux de hard-bounce</a> (" + option.data.tx_bounce_limit + "% d'emails envoyés) autorisé à " + percentEnvoi + "% de votre envoi."
                            //if (option.bddCtrl.objCptCli.objetMetier.hasServeurSmtpDedie()) {
                            //    txt += "pour protéger votre serveur smtp dédié, tous les messages suivants ont été envoyés en <a href='" + parametre.url_cognoss + "/" + parametre.code_appli + "/0/39/mode_degrade/bc' target='_blank'>mode dégradé</a>."
                            //} else {
                            txt += "pour protéger nos serveurs mutualisés et garantir une délivrabilité optimale pour tous nos utilisateurs, tous les messages suivants ont été envoyés en <a href='" + parametre.url_cognoss + "/" + parametre.code_appli + "/0/39/mode_degrade/bc' target='_blank'>mode dégradé</a>."
                            //}
                        }
                        $("<div class='dxwarningformtext'>" + txt + "</div>").appendTo(contentElement)
                        //var $A = $("<a href='javascript:void(0)' style='font-size:80%;' >Acheter un smtp dédié</a>").appendTo(contentElement)
                        //$A.on("click", function (e) {
                        //    $("<div/>").appendTo("body").dxCtrlAchatPopupSmtpDedie({
                        //        bddCtrl: option.bddCtrl
                        //    })
                        //})
                        dxWarningForm.show()
                    })
                    //var json = JSON.parse(option.data.json_type_smtp_forcer)
                    //var txt = ""
                    //var percentEnvoi = parseInt(parseInt(json.nb_email_envoye) / parseInt(json.nb_email_total) * 100)
                    //var percentRestant = 100 - percentEnvoi
                    //if (json.taux_bounce_ref != "0") {
                    //    var tauxBounce = parseInt(json.taux_hard_bounce * 10000) / 100
                    //    txt = "L'envoi de votre emailing a dépassé le taux de bounce (" + tauxBounce + "% d'emails envoyés) autorisé à " + percentEnvoi + "% de votre envoi."
                    //} else if (json.taux_spam_ref != "0") {
                    //    var tauxSpam = parseInt(json.taux_spam * 10000) / 100
                    //    txt = "L'envoi de votre emailing a dépassé le taux de bounce (" + tauxSpam + "% d'emails envoyés) autorisé à " + percentEnvoi + "% de votre envoi."
                    //}
                    //txt += "<br/>" + "Les " + percentRestant + "% restant de votre mailing ont été envoyé en mode dégradé."
                    //if (json.taux_bounce_ref != "0") {
                    //    txt += "<br/>" +
                    //        "<div style='font-size:80%;line-height:1.2;'><i>(Au dela d'un taux de bounce de " + (parseInt(json.taux_bounce_ref * 10000) / 100) + "%,"
                    //} else if (json.taux_spam_ref != "0") {
                    //    txt += "<br/>" +
                    //        "<div style='font-size:80%;line-height:1.2;'><i>(Au dela d'un taux de spam de " + (parseInt(json.taux_spam_ref * 10000) / 100) + "%,"
                    //}
                    //txt += " pour protéger nos serveurs mutualisés et garantir une délivrabilité optimale pour tous nos utilisateurs, les mailings dépassant cette limite sont automatiquement basculé en mode dégradé avec une délivrabilité moindre. Vous pouvez choisir de prendre un SMTP dédié pour augmenter cette limite et améliorer votre délivrabilité.)</i></div>"
                },
                onClose: function (component) {
                    component.hide()
                    $DivContainer.css("height", "100%")
                }
            }).dxCtrlWarningForm("instance")
        } else if (option.data.id_type_classement == 9 && option.data.error != null && option.data.error.length > 0) {
            dxWarningForm = $("<div style='margin:2px;'/>").appendTo($DivWarning).dxCtrlWarningForm({
                type: "error",
                icon: "fas fa-triangle-exclamation",
                contentTemplate: function (contentElement) {
                    var $Table = $("<table/>").appendTo(contentElement)
                    var $Tr = $("<tr/>").appendTo($Table)
                    var $Td = $("<td style='width:100%'/>").appendTo($Tr)
                    $("<div class='dxwarningformtext'>Nous avons rencontré l'erreur «<i>" + option.data.error + "</i>» durant la dernière tentative d'envoi.</div>").appendTo($Td)
                    $("<div class='dxwarningformtext'>Prochaine tentative d'envoi <b>" + option.data.date_envoi.toDateIlya() + "</b>.</div>").appendTo($Td)
                    var $Td = $("<td style='width:1%'/>").appendTo($Tr)
                    $("<div/>").appendTo($Td).dxCtrlButton({
                        text: "Renvoyer immédiatement",
                        hint: "En renvoyant votre email immédiatement, votre message sera renvoyé via les serveur smtp de " + parametre.nom,
                        onClick: function (e) {
                            option.data.date_envoi = parametre.dateNow
                            option.data.id_type_smtp_forcer = 4 //on force sur le smtp2go quotidien
                            option.data.id_type_classement = 9
                            option.data.nb_error = 0
                            option.data.error = null
                            option.bddCtrl.getObjet(option.data).mSave()
                            page.mRemovePopup(option.data)
                            //onClick: function (e) {
                            //    option.data.date_envoi = parametre.dateNow
                            //    option.bddCtrl.getObjet(option.data).mSaveChamp("date_envoi")
                            //    page.mRemovePopup(option.data)
                        }
                    })
                },
                //html: function () { return "<span class='dxwarningformtext'>Nous avons rencontré l'erreur «<i>" + option.data.error + "</i>» durant la dernière tentative d'envoi.</span>"; },
                onClose: function (component) {
                    component.hide()
                    $DivContainer.css("height", "100%")
                }
            }).dxCtrlWarningForm("instance")
        }
        //if (type == "email" && option.data.id_type_smtp_forcer != null && option.data.json_type_smtp_forcer != null && option.data.json_type_smtp_forcer.length > 0) {
        //    dxWarningForm = $("<div style='margin:5px'/>").appendTo(container).dxCtrlWarningForm({
        //        type: "warning",
        //        contentTemplate: function (contentElement) {
        //            var json = JSON.parse(option.data.json_type_smtp_forcer)
        //            var txt = ""
        //            var percentEnvoi = parseInt(parseInt(json.nb_email_envoye) / parseInt(json.nb_email_total) * 100)
        //            var percentRestant = 100 - percentEnvoi
        //            if (json.taux_bounce_ref != "0") {
        //                var tauxBounce = parseInt(json.taux_hard_bounce * 10000) / 100
        //                txt = "L'envoi de votre emailing a dépassé le taux de bounce (" + tauxBounce + "% d'emails envoyés) autorisé à " + percentEnvoi + "% de votre envoi."
        //            } else if (json.taux_spam_ref != "0") {
        //                var tauxSpam = parseInt(json.taux_spam * 10000) / 100
        //                txt = "L'envoi de votre emailing a dépassé le taux de bounce (" + tauxSpam + "% d'emails envoyés) autorisé à " + percentEnvoi + "% de votre envoi."
        //            }
        //            txt += "<br/>" + "Les " + percentRestant + "% restant de votre mailing ont été envoyé en mode dégradé."
        //            if (json.taux_bounce_ref != "0") {
        //                txt += "<br/>" +
        //                    "<div style='font-size:80%;line-height:1.2;'><i>(Au dela d'un taux de bounce de " + (parseInt(json.taux_bounce_ref * 10000) / 100) + "%,"
        //            } else if (json.taux_spam_ref != "0") {
        //                txt += "<br/>" +
        //                    "<div style='font-size:80%;line-height:1.2;'><i>(Au dela d'un taux de spam de " + (parseInt(json.taux_spam_ref * 10000) / 100) + "%,"
        //            }
        //            txt += " pour protéger nos serveurs mutualisés et garantir une délivrabilité optimale pour tous nos utilisateurs, les mailings dépassant cette limite sont automatiquement basculé en mode dégradé avec une délivrabilité moindre. Vous pouvez choisir de prendre un SMTP dédié pour augmenter cette limite et améliorer votre délivrabilité.)</i></div>"
        //            $("<div class='dxwarningformtext'>" + txt + "</div>").appendTo(contentElement)
        //            var $A = $("<a href='javascript:void(0)' style='font-size:80%;'>En savoir plus sur les smtp dédié</a>").appendTo(contentElement)
        //            $A.on("click", function (e) {
        //                $("<div/>").appendTo("body").dxCtrlAchatPopupSmtpDedie({
        //                    bddCtrl: option.bddCtrl
        //                })
        //            })
        //        },
        //        onClose: function (component) {
        //            component.hide()
        //            $DivContainer.css("height", "100%")
        //        }
        //    }).dxCtrlWarningForm("instance")
        //}

        var $DivContainer = $("<div style='height:calc(100% - " + $DivWarning.innerHeight() + "px);position:relative;'/>").appendTo(container)
        resizeObserver.mAdd($DivWarning, function () { $DivContainer.css("height", "calc(100% - " + $DivWarning.innerHeight() + "px)") })

        var ds = ["Statistiques", "Destinataires", "Vues", "Clicks", "Désinscriptions", "Bounces", "Message"]
        var $DivTab = $("<div style='border-top:" + theme.border + ";border-bottom:" + theme.border + ";'/>").appendTo($DivContainer)
        dxTabs = $("<div style='width:100%;'/>").appendTo($DivTab).dxTabs({
            dataSource: ds,
            selectedItem: ds[0],
            showNavButtons: true,//parametre.isPhone,
            //scrollingEnabled:false,
            itemTemplate: function (itemData, itemIndex, itemElement) {
                itemElement.empty()
                itemElement.parent().attr("title", itemData)
                itemElement.css("position", "relative")
                itemElement.css("font-family", "barlow condensed")
                //if (parametre.isPhone) itemElement.closest(".dx-item").css({ "max-width": "50px", "min-width": "50px" })
                switch (itemData) {
                    case "Statistiques":
                        //itemElement.text(((parametre.isPhone) ? "Stat" : itemData))
                        var divCpt = $("<div style='white-space:nowrap;padding:3px 10px;text-align:center;border-radius:50%;min-width:18px;font-size:110%;'/>").appendTo(itemElement)
                        $("<i class='fas fa-chart-pie' style='font-size:110%;'></i>").appendTo(divCpt)
                        break;
                    case "Message":
                        //itemElement.text(((parametre.isPhone) ? "Mess" : itemData))
                        var divCpt = $("<div style='white-space:nowrap;padding:3px 10px;text-align:center;border-radius:50%;min-width:18px;font-size:110%;'/>").appendTo(itemElement)
                        $("<i class='fas fa-file' style='font-size:110%;'></i>").appendTo(divCpt)
                        break;
                    case "Destinataires": case "Vues": case "Clicks": case "Désinscriptions": case "Bounces":
                        //itemElement.text(((parametre.isPhone) ? "Mess" : itemData))
                        //switch (itemData) {
                        //    case "Destinataires": itemElement.text(((parametre.isPhone) ? "Dest" : itemData)); break;
                        //    case "Désinscriptions": itemElement.text(((parametre.isPhone) ? "Désins" : itemData)); break;
                        //    case "Vues": case "Bounces": case "Clicks": itemElement.text(((parametre.isPhone) ? itemData : itemData)); break;
                        //}
                        if (itemData == "Destinataires") {
                            var divCpt = $("<div style='white-space:nowrap;padding:3px 10px;text-align:center;border-radius:50%;min-width:18px;font-size:110%;'/>").appendTo(itemElement)
                            option.bddCtrl.mAjaxCall({ command: "getdataslstdestnb", idtablecom: idTable, idcom: id }, function (data) {
                                data.lstcomdest = JSON.parse(data.lstcomdest)
                                //if (typeof data.lstcomdest == 'undefined') data.lstcomdest = []
                                divCpt.html("<i class='fas fa-users' style='font-size:110%;'></i> " + data.lstcomdest[0].nb)
                            })
                        } else {
                            //var $DivIcone = $("<div style=''/>").appendTo(itemElement)
                            var divCpt = $("<div style='white-space:nowrap;padding:3px 10px;text-align:center;border-radius:50%;min-width:18px;font-size:110%;'/>").appendTo(itemElement)
                            //switch (itemData) {
                            //    case "Vues":
                            //        $("<i class='fas fa-eye' style='font-size:160%;'></i>").appendTo($DivIcone)
                            //        break;
                            //    case "Clicks":
                            //        $("<i class='fas fa-arrow-pointer' style='font-size:160%;'></i>").appendTo($DivIcone)
                            //        break;
                            //    case "Désinscriptions":
                            //        $("<i class='fas fa-user-secret' style='font-size:160%;'></i>").appendTo($DivIcone)
                            //        break;
                            //    case "Bounces":
                            //        $("<i class='fas fa-ghost' style='font-size:160%;'></i>").appendTo($DivIcone)
                            //        break;
                            //}
                            mCharge()
                            function mCharge() {
                                if (container.closest("body").length == 0) return
                                //                       case "Vues":
                                //    option.bddCtrl.mAjaxCall({ command: "getdatas", nomtable: "lstvue", sql: "select count(*) as nb from com_" + type + "_envoi_tracking_vue where is_robot=0 and id_com_" + type + "_envoi=" + id }, function (data) {
                                //        if (typeof data.lstvue == 'undefined') data.lstvue = []
                                //        divCpt.html("<i class='fas fa-eye' style='font-size:110%;'></i> " + data.lstvue[0].nb)
                                //    })
                                //    break;
                                //case "Clicks":
                                //    option.bddCtrl.mAjaxCall({ command: "getdatas", nomtable: "lstclick", sql: "select count(*) as nb from com_" + type + "_envoi_tracking_click where is_robot=0 and id_com_" + type + "_envoi=" + id }, function (data) {
                                //        if (typeof data.lstclick == 'undefined') data.lstclick = []
                                //        divCpt.html("<i class='fas fa-arrow-pointer' style='font-size:110%;'></i> " + data.lstclick[0].nb)
                                //    })
                                //    break;
                                //case "Désinscriptions":
                                //    option.bddCtrl.mAjaxCall({ command: "getdatas", nomtable: "lstDesinscription", sql: "select count(*) as nb from com_destinataire where id_table_com=" + idTable + " and id_com=" + id + " and not date_desinscription is null" }, function (data) {
                                //        if (typeof data.lstDesinscription == 'undefined') data.lstDesinscription = []
                                //        divCpt.html("<i class='fas fa-user-secret' style='font-size:110%;'></i> " + data.lstDesinscription[0].nb)
                                //    })
                                //    break;
                                //case "Bounces":
                                //    option.bddCtrl.mAjaxCall({ command: "getdatas", nomtable: "lstBounce", sql: "select count(*) as nb from com_destinataire where id_table_com=" + idTable + " and id_com=" + id + " and (not date_bounce is null or not date_mise_en_spam is null)" }, function (data) {
                                //        if (typeof data.lstBounce == 'undefined') data.lstBounce = []
                                //        divCpt.html("<i class='fas fa-ghost' style='font-size:110%;'></i> " + data.lstBounce[0].nb)
                                //    })
                                //    break;
                                switch (itemData) {
                                    case "Vues":
                                        option.bddCtrl.mAjaxCall({ command: "getdataslstvuenb", type: type, id: id }, function (data) {
                                            data.lstvue = JSON.parse(data.lstvue)
                                            //if (typeof data.lstvue == 'undefined') data.lstvue = []
                                            divCpt.html("<i class='fas fa-eye' style='font-size:110%;'></i> " + data.lstvue[0].nb)
                                        })
                                        break;
                                    case "Clicks":
                                        option.bddCtrl.mAjaxCall({ command: "getdataslstclicknb", type: type, id: id }, function (data) {
                                            data.lstclick = JSON.parse(data.lstclick)
                                            //if (typeof data.lstclick == 'undefined') data.lstclick = []
                                            divCpt.html("<i class='fas fa-arrow-pointer' style='font-size:110%;'></i> " + data.lstclick[0].nb)
                                        })
                                        break;
                                    case "Désinscriptions":
                                        option.bddCtrl.mAjaxCall({ command: "getdataslstdesinscription", idtable: idTable, id: id }, function (data) {
                                            data.lstDesinscription = JSON.parse(data.lstDesinscription)
                                            //if (typeof data.lstDesinscription == 'undefined') data.lstDesinscription = []
                                            divCpt.html("<i class='fas fa-user-secret' style='font-size:110%;'></i> " + data.lstDesinscription[0].nb)
                                        })
                                        break;
                                    case "Bounces":
                                        option.bddCtrl.mAjaxCall({ command: "getdataslstbounce", idtable: idTable, id: id }, function (data) {
                                            data.lstBounce = JSON.parse(data.lstBounce)
                                            //if (typeof data.lstBounce == 'undefined') data.lstBounce = []
                                            divCpt.html("<i class='fas fa-ghost' style='font-size:110%;'></i> " + data.lstBounce[0].nb)
                                        })
                                        break;
                                }
                                if (option.data.date_envoi == null || Math.abs(diffdate(option.data.date_envoi, parametre.dateNow, "d")) < 10) window.setTimeout(function () { mCharge() }, 10000)
                            }
                        }
                        break;
                }
                switch (itemData) {
                    case "Destinataires": $("<div/>").appendTo(itemElement).text(((parametre.isPhone) ? "Dest" : itemData)); break;
                    case "Désinscriptions": $("<div/>").appendTo(itemElement).text(((parametre.isPhone) ? "Désins" : itemData)); break;
                    case "Vues": case "Bounces": case "Clicks": $("<div/>").appendTo(itemElement).text(((parametre.isPhone) ? itemData : itemData)); break;
                    default: $("<div/>").appendTo(itemElement).text(((parametre.isPhone) ? "Mess" : itemData)); break;
                }

                itemElement.css("display", "block")
                itemElement.css("text-align", "center")
            },
            onSelectionChanged: function (e) {
                //jauge.mShow()
                switch (e.addedItems[0]) {
                    case "Statistiques": mRempliStat(); break;
                    case "Destinataires": mRempliDestinataire(); break;
                    case "Vues": mRempliVue(); break;
                    case "Clicks": mRempliClick(); break;
                    case "Désinscriptions": mRempliDesinscription(); break;
                    case "Bounces": mRempliBounce(); break;
                    case "Message": mRempliMessage(); break;
                }
            }
        }).dxTabs("instance")

        //$DivContentStat = $("<div style='padding:5px 10px 10px 10px;position:absolute;width:100%;height:calc(100% - " + ((!dxTabs) ? "0" : (dxTabs.element().innerHeight() + 20)) + "px);display:none;'/>").appendTo($DivContainer)
        $DivContentStat = $("<div style='position:absolute;width:100%;height:calc(100% - " + ((!dxTabs) ? "0" : (dxTabs.element().innerHeight() + 20)) + "px);display:none;'/>").appendTo($DivContainer)
        $DivContentDest = $("<div style='position:absolute;width:100%;height:calc(100% - " + ((!dxTabs) ? "0" : (dxTabs.element().innerHeight() + 20)) + "px);display:none;display:none;'/>").appendTo($DivContainer)
        $DivContentVue = $("<div style='position:absolute;width:100%;height:calc(100% - " + ((!dxTabs) ? "0" : (dxTabs.element().innerHeight() + 20)) + "px);display:none;display:none;'/>").appendTo($DivContainer)
        $DivContentClick = $("<div style='position:absolute;width:100%;height:calc(100% - " + ((!dxTabs) ? "0" : (dxTabs.element().innerHeight() + 20)) + "px);display:none;display:none;'/>").appendTo($DivContainer)
        $DivContentDesinscription = $("<div style='position:absolute;width:100%;height:calc(100% - " + ((!dxTabs) ? "0" : (dxTabs.element().innerHeight() + 20)) + "px);display:none;display:none;'/>").appendTo($DivContainer)
        $DivContentBounce = $("<div style='position:absolute;width:100%;height:calc(100% - " + ((!dxTabs) ? "0" : (dxTabs.element().innerHeight() + 20)) + "px);display:none;display:none;'/>").appendTo($DivContainer)
        $DivContentMessage = $("<div style='position:absolute;width:100%;height:calc(100% - " + ((!dxTabs) ? "0" : (dxTabs.element().innerHeight() + 20)) + "px);display:none;display:none;'/>").appendTo($DivContainer)

        mRempliStat()
    }

    var $DivCurrent = null
    function mRempliStat() {
        if ($DivCurrent != null) {
            var oldDivCurrent = $DivCurrent
            oldDivCurrent.stop()
            oldDivCurrent.fadeOut(300, function () { oldDivCurrent.empty() })
        }
        $DivCurrent = $DivContentStat
        $("<div style='width:100%;height:100%;'/>").appendTo($DivCurrent).dxCtrlContentComEnvoiStat({
            bddCtrl: option.bddCtrl,
            data: option.data,
            type: type
        })
        $DivCurrent.fadeIn(300, function () { })
    }
    var dxGridDest = null
    function mRempliDestinataire() {
        if ($DivCurrent != null) {
            var oldDivCurrent = $DivCurrent
            oldDivCurrent.stop()
            oldDivCurrent.fadeOut(300, function () { oldDivCurrent.empty() })
        }
        $DivCurrent = $DivContentDest
        dxGridDest = $("<div/>").appendTo($DivCurrent).dxCtrlGridComDestinataire({
            bddCtrl: option.bddCtrl,
            context_grid: "list_destinataire_tracking" + type + "2",
            noDataText: "Aucun destinataire",
            id_table_com: idTable,
            id_com: id,
            typeData: "comdest" + type,
            typeGrille: "Lignes",
            allowCheck: false,
            allowFilter: false,
            orderBounce: false,
            allowGroup: true,
            showColumnHeaders: true,
            onClickDataGrid: function (container, dataGrid, dataTemplate) {
                if (typeof dataTemplate.com_dest.id_table_destinataire != 'undefined' && dataTemplate.com_dest.id_table_destinataire != null) {
                    var table = option.bddCtrl.table.mGetItem(dataTemplate.com_dest.id_table_destinataire)
                    option.bddCtrl.getObjet(table.nom, dataTemplate.com_dest.id_destinataire).mShowPopup()
                } else {
                    option.bddCtrl.getObjet("com_destinataire").objetMetier.mCreateContactFromComDest(container, dataTemplate.com_dest, function () {
                        dxGridDest.mReloadData()
                    })
                }
            },
            getItemsToolBar: function (dxGridComDest) {
                var lst = []
                lst.push({
                    location: 'before',
                    template: function (itemData, itemIndex, itemElement) {
                        itemElement.closest(".dx-toolbar-item").css("background-color", theme.backgroundcolorBase)
                        $("<div/>").appendTo(itemElement).dxCtrlButton({
                            icon: "fas fa-bars-staggered",
                            icon2: "fas fa-ellipsis",
                            colorIcone2: theme.colorBtIcon2,
                            opacityIcone2: "0.9",
                            hint: "Afficher la grille structures/contacts des clicks",
                            onClick: function (e) {
                                var xlstIdTableId = ""
                                dxGridComDest.mGetLstTraitementData().forEach(function (dataGrid) {
                                    xlstIdTableId += ((xlstIdTableId.length > 0) ? "," : "") + dataGrid.id
                                })
                                if (xlstIdTableId.length > 0) {
                                    option.bddCtrl.mAjaxCall({ command: "getdatasfromlstidcomdest", lstid: xlstIdTableId }, function (data) {
                                        data.lst = JSON.parse(data.lst)
                                        //if (typeof data.lst == 'undefined') data.lst = []
                                        if (data.lst.length > 0) {
                                            page.mAddPopupLst("Liste des envois &bull; " + option.data.objet, function (contentElement) {
                                                $("<div style='width:100%;height:100%;'/>").appendTo(contentElement).dxCtrlPopupLstStrConTempo({
                                                    bddCtrl: option.bddCtrl,
                                                    lstIdTableIdInclu: data.lst
                                                })
                                            })
                                        } else { mNotify("Aucune fiche à afficher", "warning", 6000) }
                                    })
                                } else { mNotify("Aucune fiche à afficher", "warning", 6000) }
                            }
                        }).dxCtrlButton("instance")
                    }
                })
                //lst.push({
                //    location: 'before',
                //    template: function (itemData, itemIndex, itemElement) {
                //        itemElement.closest(".dx-toolbar-item").css("background-color", theme.backgroundcolorBase)
                //        option.bddCtrl.getObjet("dossier").objetMetier.mGetButtonToolBarAddDansDossier(itemElement, function () { return dxGrid }, "select distinct com_destinataire.id_table_destinataire as id_table,com_destinataire.id_destinataire as id from com_destinataire inner join (select value as id from string_split('%lstid%',',')) as tab ON com_destinataire.id_com_destinataire=tab.id where not com_destinataire.id_destinataire is null")
                //    }
                //})
                //lst.push({
                //    location: 'before',
                //    template: function (itemData, itemIndex, itemElement) {
                //        option.bddCtrl.getObjet("pipeline").objetMetier.mGetButtonToolBarAddDansPipeline(itemElement,function () { return dxGridComDest.mGetDxGrid() }, "select distinct com_destinataire.id_table_destinataire as id_table,com_destinataire.id_destinataire as id from com_destinataire inner join (select value as id from string_split('%lstid%',',')) as tab ON com_destinataire.id_com_destinataire=tab.id where not com_destinataire.id_destinataire is null")
                //    }
                //})
                ////lst.push(option.bddCtrl.getObjet("dossier").objetMetier.mGetButtonToolBarAddDansDossier(function () { return dxGridComDest.mGetDxGrid() }, "select distinct com_destinataire.id_table_destinataire as id_table,com_destinataire.id_destinataire as id from com_destinataire inner join (select value as id from string_split('%lstid%',',')) as tab ON com_destinataire.id_com_destinataire=tab.id where not com_destinataire.id_destinataire is null"))
                ////lst.push(option.bddCtrl.getObjet("pipeline").objetMetier.mGetButtonToolBarAddDansPipeline(function () { return dxGridComDest.mGetDxGrid() }, "select distinct com_destinataire.id_table_destinataire as id_table,com_destinataire.id_destinataire as id from com_destinataire inner join (select value as id from string_split('%lstid%',',')) as tab ON com_destinataire.id_com_destinataire=tab.id where not com_destinataire.id_destinataire is null"))
                return lst
            }
        }).dxCtrlGridComDestinataire("instance")
        $DivCurrent.fadeIn(300, function () { })
    }
    function mRempliVue() {
        if ($DivCurrent != null) {
            var oldDivCurrent = $DivCurrent
            oldDivCurrent.stop()
            oldDivCurrent.fadeOut(300, function () { oldDivCurrent.empty() })
        }
        $DivCurrent = $DivContentVue
        switch (type) {
            case "email":
                $("<div style='width:100%;height:100%;'/>").appendTo($DivCurrent).dxCtrlGridComDestinataireTrackingVueEmail({
                    bddCtrl: option.bddCtrl,
                    objet: option.data.objet,
                    context_grid: "vueemailsmscom",
                    lstLstConditionBase: [[{ nom_champ: "id_com_email_envoi", ope: "=", valeur: [{ value: option.data.id_com_email_envoi }] }]],
                    showBtNew: false,
                    showVoirDoc: false
                })
                break;
            case "sms":
                $("<div style='width:100%;height:100%;'/>").appendTo($DivCurrent).dxCtrlGridComDestinataireTrackingVueSms({
                    bddCtrl: option.bddCtrl,
                    context_grid: "clickemailsmscom",
                    objet: option.data.body_txt,
                    lstLstConditionBase: [[{ nom_champ: "id_com_" + type + "_envoi", ope: "=", valeur: [{ value: id }] }]],
                    showBtNew: false,
                    showVoirDoc: false
                })
                break;
        }
        $DivCurrent.fadeIn(300, function () { })
    }
    function mRempliClick() {
        if ($DivCurrent != null) {
            var oldDivCurrent = $DivCurrent
            oldDivCurrent.stop()
            oldDivCurrent.fadeOut(300, function () { oldDivCurrent.empty() })
        }
        $DivCurrent = $DivContentClick
        switch (type) {
            case "email":
                $("<div style='width:100%;height:100%;'/>").appendTo($DivCurrent).dxCtrlGridComDestinataireTrackingClickEmail({
                    bddCtrl: option.bddCtrl,
                    objet: option.data.objet,
                    lstLstConditionBase: [[{ nom_champ: "id_com_email_envoi", ope: "=", valeur: [{ value: option.data.id_com_email_envoi }] }]],
                    showBtNew: false,
                    showVoirDoc: false
                })
                break;
            case "sms":
                $("<div style='width:100%;height:100%;'/>").appendTo($DivCurrent).dxCtrlGridComDestinataireTrackingClickSms({
                    bddCtrl: option.bddCtrl,
                    objet: option.data.body_txt,
                    lstLstConditionBase: [[{ nom_champ: "id_com_" + type + "_envoi", ope: "=", valeur: [{ value: id }] }]],
                    showBtNew: false,
                    showVoirDoc: false
                })
                break;
        }
        $DivCurrent.fadeIn(300, function () { })
    }
    function mRempliDesinscription() {
        if ($DivCurrent != null) {
            var oldDivCurrent = $DivCurrent
            oldDivCurrent.stop()
            oldDivCurrent.fadeOut(300, function () { oldDivCurrent.empty() })
        }
        $DivCurrent = $DivContentDesinscription
        $("<div/>").appendTo($DivCurrent).dxCtrlGridComDestinataire({
            bddCtrl: option.bddCtrl,
            context_grid: "list_destinataire_bounce_" + type + "2",
            noDataText: "Aucun destinataire en bounce",
            id_table_com: idTable,
            id_com: id,
            typeData: "comdest" + type,
            typeGrille: "Lignes",
            lstLstConditionBase: [[{ nom_champ: "date_desinscription", ope: "notisblank" }]],
            allowFilter: false,
            allowCheck: false,
            showBtNew: false,
            orderBounce: true,
            allowGroup: true,
            onClickDataGrid: function (container, dataGrid, dataTemplate) {
                if (typeof dataTemplate.com_dest.id_table_destinataire != 'undefined' && dataTemplate.com_dest.id_table_destinataire != null) {
                    var table = option.bddCtrl.table.mGetItem(dataTemplate.com_dest.id_table_destinataire)
                    option.bddCtrl.getObjet(table.nom, dataTemplate.com_dest.id_destinataire).mShowPopup()
                } else {
                    option.bddCtrl.getObjet("com_destinataire").objetMetier.mCreateContactFromComDest(container, dataTemplate.com_dest, function () {
                        dxGridDest.mReloadData()
                    })
                }
            },
            getItemsToolBar: function (dxGridComDest) {
                var lst = []
                lst.push({
                    location: 'before',
                    template: function (itemData, itemIndex, itemElement) {
                        itemElement.closest(".dx-toolbar-item").css("background-color", theme.backgroundcolorBase)
                        $("<div/>").appendTo(itemElement).dxCtrlButton({
                            icon: "fas fa-bars-staggered",
                            icon2: "fas fa-ellipsis",
                            colorIcone2: theme.colorBtIcon2,
                            opacityIcone2: "0.9",
                            hint: "Afficher la grille structures/contacts des clicks",
                            onClick: function (e) {
                                var xlstIdTableId = ""
                                dxGridComDest.mGetLstTraitementData().forEach(function (dataGrid) {
                                    xlstIdTableId += ((xlstIdTableId.length > 0) ? "," : "") + dataGrid.id
                                })
                                if (xlstIdTableId.length > 0) {
                                    option.bddCtrl.mAjaxCall({ command: "getdatasfromlstidcomdest", lstid: xlstIdTableId }, function (data) {
                                        data.lst = JSON.parse(data.lst)
                                        //if (typeof data.lst == 'undefined') data.lst = []
                                        if (data.lst.length > 0) {
                                            page.mAddPopupLst("Liste des bounces &bull; " + option.data.objet, function (contentElement) {
                                                $("<div style='width:100%;height:100%;'/>").appendTo(contentElement).dxCtrlPopupLstStrConTempo({
                                                    bddCtrl: option.bddCtrl,
                                                    lstIdTableIdInclu: data.lst
                                                })
                                            })
                                        } else { mNotify("Aucune fiche à afficher", "warning", 6000) }
                                    })
                                } else { mNotify("Aucune fiche à afficher", "warning", 6000) }
                            }
                        }).dxCtrlButton("instance")
                    }
                })
                return lst
            }
        }).dxCtrlGridComDestinataire("instance")


        //switch (type) {
        //    case "email":
        //        $("<div/>").appendTo($DivCurrent).dxCtrlGridAdresseEmailListeNoire({
        //            bddCtrl: option.bddCtrl,
        //            objet: option.data.objet,
        //            lstLstConditionBase: [[{ nom_champ: "id_com_email_envoi", ope: "=", valeur: [{ value: option.data.id_com_email_envoi }] }]],
        //            showBtNew: false
        //        })
        //        break;
        //    case "sms":
        //        $("<div/>").appendTo($DivCurrent).dxCtrlGridTelSmsListeNoire({
        //            bddCtrl: option.bddCtrl,
        //            objet: option.data.body_txt,
        //            lstLstConditionBase: [[{ nom_champ: "id_com_" + type + "_envoi", ope: "=", valeur: [{ value: id }] }]],
        //            showBtNew: false
        //        })
        //        break;
        //}
        $DivCurrent.fadeIn(300, function () { })
    }
    function mRempliBounce() {
        if ($DivCurrent != null) {
            var oldDivCurrent = $DivCurrent
            oldDivCurrent.stop()
            oldDivCurrent.fadeOut(300, function () { oldDivCurrent.empty() })
        }
        $DivCurrent = $DivContentBounce
        $("<div/>").appendTo($DivCurrent).dxCtrlGridComDestinataire({
            bddCtrl: option.bddCtrl,
            context_grid: "list_destinataire_bounce_" + type + "2",
            noDataText: "Aucun destinataire en bounce",
            id_table_com: idTable,
            id_com: id,
            typeData: "comdest" + type,
            typeGrille: "Lignes",
            lstLstConditionBase: [[{ nom_champ: "id_statut_erreur", ope: "notparmi", valeur: [{ value: 0 }] }]],
            allowFilter: false,
            allowCheck: false,
            showBtNew: false,
            orderBounce: true,
            allowGroup: true,
            onClickDataGrid: function (container, dataGrid, dataTemplate) {
                if (typeof dataTemplate.com_dest.id_table_destinataire != 'undefined' && dataTemplate.com_dest.id_table_destinataire != null) {
                    var table = option.bddCtrl.table.mGetItem(dataTemplate.com_dest.id_table_destinataire)
                    option.bddCtrl.getObjet(table.nom, dataTemplate.com_dest.id_destinataire).mShowPopup()
                } else {
                    option.bddCtrl.getObjet("com_destinataire").objetMetier.mCreateContactFromComDest(container, dataTemplate.com_dest, function () {
                        dxGridDest.mReloadData()
                    })
                }
            },
            getItemsToolBar: function (dxGridComDest) {
                var lst = []
                lst.push({
                    location: 'before',
                    template: function (itemData, itemIndex, itemElement) {
                        itemElement.closest(".dx-toolbar-item").css("background-color", theme.backgroundcolorBase)
                        $("<div/>").appendTo(itemElement).dxCtrlButton({
                            icon: "fas fa-bars-staggered",
                            icon2: "fas fa-ellipsis",
                            colorIcone2: theme.colorBtIcon2,
                            opacityIcone2: "0.9",
                            hint: "Afficher la grille structures/contacts des clicks",
                            onClick: function (e) {
                                var xlstIdTableId = ""
                                dxGridComDest.mGetLstTraitementData().forEach(function (dataGrid) {
                                    xlstIdTableId += ((xlstIdTableId.length > 0) ? "," : "") + dataGrid.id
                                })
                                if (xlstIdTableId.length > 0) {
                                    option.bddCtrl.mAjaxCall({ command: "getdatasfromlstidcomdest", lstid: xlstIdTableId }, function (data) {
                                        data.lst = JSON.parse(data.lst)
                                        //if (typeof data.lst == 'undefined') data.lst = []
                                        if (data.lst.length > 0) {
                                            page.mAddPopupLst("Liste des bounces &bull; " + option.data.objet, function (contentElement) {
                                                $("<div style='width:100%;height:100%;'/>").appendTo(contentElement).dxCtrlPopupLstStrConTempo({
                                                    bddCtrl: option.bddCtrl,
                                                    lstIdTableIdInclu: data.lst
                                                })
                                            })
                                        } else { mNotify("Aucune fiche à afficher", "warning", 6000) }
                                    })
                                } else { mNotify("Aucune fiche à afficher", "warning", 6000) }
                            }
                        }).dxCtrlButton("instance")
                    }
                })

                //lst.push({
                //    location: 'before',
                //    template: function (itemData, itemIndex, itemElement) {
                //        option.bddCtrl.getObjet("dossier").objetMetier.mGetButtonToolBarAddDansDossier(itemElement, function () { return dxGridComDest.mGetDxGrid() }, "select distinct com_destinataire.id_table_destinataire as id_table,com_destinataire.id_destinataire as id from com_destinataire inner join (select value as id from string_split('%lstid%',',')) as tab ON com_destinataire.id_com_destinataire=tab.id where not com_destinataire.id_destinataire is null")
                //    }
                //})

                //lst.push({
                //    location: 'before',
                //    template: function (itemData, itemIndex, itemElement) {
                //        option.bddCtrl.getObjet("pipeline").objetMetier.mGetButtonToolBarAddDansPipeline(itemElement, function () { return dxGridComDest.mGetDxGrid() }, "select distinct com_destinataire.id_table_destinataire as id_table,com_destinataire.id_destinataire as id from com_destinataire inner join (select value as id from string_split('%lstid%',',')) as tab ON com_destinataire.id_com_destinataire=tab.id where not com_destinataire.id_destinataire is null")
                //    }
                //})
                //lst.push(option.bddCtrl.getObjet("dossier").objetMetier.mGetButtonToolBarAddDansDossier(function () { return dxGridComDest.mGetDxGrid() }, "select distinct com_destinataire.id_table_destinataire as id_table,com_destinataire.id_destinataire as id from com_destinataire inner join (select value as id from string_split('%lstid%',',')) as tab ON com_destinataire.id_com_destinataire=tab.id where not com_destinataire.id_destinataire is null"))
                //lst.push(option.bddCtrl.getObjet("pipeline").objetMetier.mGetButtonToolBarAddDansPipeline(function () { return dxGridComDest.mGetDxGrid() }, "select distinct com_destinataire.id_table_destinataire as id_table,com_destinataire.id_destinataire as id from com_destinataire inner join (select value as id from string_split('%lstid%',',')) as tab ON com_destinataire.id_com_destinataire=tab.id where not com_destinataire.id_destinataire is null"))
                return lst
            }
        }).dxCtrlGridComDestinataire("instance")
        $DivCurrent.fadeIn(300, function () { })
    }
    function mRempliMessage() {
        if ($DivCurrent != null) {
            var oldDivCurrent = $DivCurrent
            oldDivCurrent.stop()
            oldDivCurrent.fadeOut(300, function () { oldDivCurrent.empty() })
        }
        $DivCurrent = $DivContentMessage
        $("<div/>").appendTo($DivCurrent).dxCtrlContentEnvoiMailingPrevi({
            bddCtrl: option.bddCtrl,
            data: option.data,
            type: type,
            readOnly: true
        })
        $DivCurrent.fadeIn(300, function () { })
    }

    this.element = function () { return container }

    mConstruit();
}